<template>
  <div class="chat-footer" @keydown="activateInput">
    <div class="pre-image-upload" v-if="attachment.file">
      <div class="image-upload">
        <img
          v-if="isImage(attachment.file.name)"
          :src="attachment.fileUrl"
          class="img-fluid"
        />
        <video v-else-if="isVideo(attachment.file.name)" height="50">
          <source :src="createObjectURL(attachment.file)" />
          Your browser does not support HTML5 video.
        </video>
        <div
          :style="{ padding: '8px 3px', position: 'relative' }"
          v-else-if="isDoc(attachment.file.name)"
        >
          <!-- <CsvIcon
            v-if="isCsv(attachment.file.name)"
            style="fill: #000"
          ></CsvIcon>
          <PdfIcon
            v-else-if="isPdf(attachment.file.name)"
            style="fill: #000"
          ></PdfIcon>
          <ExcellIcon
            v-else-if="isExcel(attachment.file.name)"
            style="fill: #000"
          ></ExcellIcon>
          <MsWordIcon
            v-else-if="isWord(attachment.file.name)"
            style="fill: #000"
          ></MsWordIcon> -->
          <file-icon :style="{color: 'gray'}" />
          <span class="file-ext" :style="{ color: 'white' }">
            {{ getFileExtDisplay(attachment.file.name) }}
          </span>
        </div>
        <p>
          {{ attachment.fileName }}

          <small class="d-block text-danger" v-if="attachment.isExceedLimit">
            {{ $t("error.fileExceed", { size: byteToMB(attachment.maxSize) }) }}
          </small>
        </p>
      </div>
      <feather-icon
        icon="XIcon"
        class="cursor-pointer"
        size="22"
        @click="removeAttachment"
      />
    </div>
    <div class="emoji-picker" v-if="isShowEmojiPicker">
      <div class="row justify-content-center">
        <div
          class="col col-auto emoji cursor-pointer"
          v-for="(emo, key) in emoji"
          :key="`emoji-${key}`"
          @click="addEmoji(emo)"
        >
          {{ emo }}
        </div>
      </div>
    </div>
    <div v-if="isShowTranslateToggle">
      <span class="quick-msg-translate">
        {{ this.translate.translatedMessage }}
      </span>
    </div>
    <div class="quick-msg" v-if="isShowQuickMsgToggle">
      <ul
        id="list"
        :style="{
          marginBottom: '0rem',
          marginTop: '0rem',
          marginLeft: '-2.9rem',
        }"
      >
        <li
          class="msg-title-message"
          ref="inputBox"
          v-for="(msg, index) in quickMessages"
          @mousedown.prevent
          @click="selectQuickMessage(msg.id)"
          :class="{ focus: index === focus }"
        >
          <a class="text-msg-title">
            {{ msg.title }}
          </a>
        </li>
        <li class="msg-title-message" v-if="quickMessages.length == 0">
          <a class="text-msg-title">
            {{ $t("general.noQuickMessage") }}
          </a>
        </li>
      </ul>
    </div>

    <b-form class="chat-app-form" @submit.prevent="sendMessage">
      <b-input-group class="input-group-merge form-send-message mr-1">
        <b-form-textarea
          ref="inputBox"
          @focus="onInputFocus"
          @input="startTyping"
          tabindex="0"
          @keyup="keyAction"
          @keydown="keyDownAction"
          @keydown.enter.exact.prevent="sendMessage"
          maxlength="455"
          v-debounce:2000ms="stopTyping"
          v-model="text"
          rows="2"
          max-rows="2"
          no-resize
          trim
          :placeholder="$t('general.enterYourMessage')"
          @click="closeEmoji"
        />
      </b-input-group>

      <feather-icon
        icon="SmileIcon"
        class="cursor-pointer mr-1"
        size="22"
        @click="openEmoji"
      />
      <b-button variant="primary" type="submit" v-if="text || attachment.file">
        {{ $t("chat.send") }}
      </b-button>

      <feather-icon
        icon="PaperclipIcon"
        class="cursor-pointer mr-1"
        size="22"
        @click="openAttachment"
        v-else
      />
    </b-form>
    <input
      type="file"
      style="display: none"
      name="fields[assetsFieldHandle][]"
      id="assetsFieldHandle"
      class="w-px h-px opacity-0 overflow-hidden absolute"
      @change="onAttachmentChange"
      ref="fileInput"
    />
    <!-- accept="image/*,video/*,.xlsx,.xls,.csv,.pdf,.docx,.doc" -->
  </div>
</template>

<script>
import store from "@/store";
import _ from "lodash";
import {
  BAvatar,
  BDropdown,
  BDropdownItem,
  BForm,
  BInputGroup,
  BFormInput,
  BButton,
  BBadge,
  BSpinner,
  BFormTextarea,
} from "bootstrap-vue";
import emoji from "@/data/emoji";
import config from "@/data/config";
import Repository from "@/repositories/RepositoryFactory";
import {
  isVideo,
  isDoc,
  isImage,
  isCsv,
  isExcel,
  isPdf,
  isWord,
  getFileExtDisplay,
} from "../../helpers/fileHelper";
import CsvIcon from "@/components/icons/CsvIcon.vue";
import FileIcon from "@/components/icons/FileIcon.vue";
import ExcellIcon from "@/components/icons/ExcellIcon.vue";
import MsWordIcon from "@/components/icons/MsWordIcon.vue";
import PdfIcon from "@/components/icons/PdfIcon.vue";
import useJwt from "@/auth/jwt/useJwt";

const ChatMessageRepository = Repository.get("chatMessage");
const QuickMessageRepository = Repository.get("quickMessage");
const TranslateRepository = Repository.get("translateRepository");
export default {
  components: {
    BAvatar,
    BDropdown,
    BDropdownItem,
    BForm,
    BInputGroup,
    BFormInput,
    BButton,
    BBadge,
    BSpinner,
    BFormTextarea,

    CsvIcon,
    PdfIcon,
    ExcellIcon,
    MsWordIcon,
    FileIcon,
  },
  props: {
    activeRoom: {
      type: Object,
      default: () => {
        return {};
      },
    },
    toggleRightSidebar: {
      type: Function,
      require: true,
    },
  },
  data() {
    return {
      attachment: {},
      isShowEmojiPicker: false,
      isTyping: false,
      isTranslating: false,

      emoji,
      config,

      text: "",
      translate: "",
      isShowTranslateToggle: false,
      isShowQuickMsgToggle: false,
      quickMessages: [],
      focus: null,
      focusInterval: null,
      qmNoResultCount: 0,
    };
  },

  watch: {
    text(value) {
      if (value.trim().startsWith("#")) {
        this.focus = 0;
        this.getQuickMessages(value.trim());
      } else {
        this.isShowQuickMsgToggle = false;
        // if (this.activeRoom?.isAutoTranslate) {
        //   this.isTranslating = true;
        //   this.manualTranslate(value);
        // }
      }
    },
    activeRoom(value, oldValue) {
      this.$nextTick(() => {
        this.bindText(value, oldValue);
      });
    },
  },
  computed: {
    userData: function () {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
            localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
          );
    },
    chatSetting: function () {
      return JSON.parse(localStorage.getItem("chatSettings"));
    },
  },
  setup() {
    return {
      isImage,
      isVideo,
      isDoc,
      isCsv,
      isExcel,
      isPdf,
      isWord,
      getFileExtDisplay,
    };
  },
  mounted() {
    this.bindText(this.activeRoom);
    window.addEventListener("paste", this.handlePaste);
    window.addEventListener("keypress", this.activateInput);
  },
  destroyed() {
    this.bindText(null, this.activeRoom);
    window.removeEventListener("paste", this.handlePaste);
    window.removeEventListener("keypress", this.activateInput);
  },
  methods: {
    bindText(value, oldValue) {
      if (oldValue) {
        store.commit("app/UPDATE_CHAT_DRAFT", {
          key: `draft_${oldValue.id}`,
          value: this.text?.trim() || undefined,
        });
      }
      this.text = store.state.app.chatDraft[`draft_${value?.id}`] || "";
    },
    activateInput(event) {
      if (event.key === "R") {
        if (document.activeElement === this.$refs.inputBox.$el) {
          return;
        }
        this.$refs.inputBox.focus();
        event.preventDefault();
      } else if (event.key === "F2") {
        if (document.activeElement !== this.$refs.inputBox.$el) {
          return;
        }
        event.preventDefault();
        this.$refs.inputBox.blur();
      }
    },
    keyAction: function (event) {
      switch (event.keyCode) {
        // 38 — up
        case 38:
          clearInterval(this.focusInterval);
          break;

        // 40 — down
        case 40:
          clearInterval(this.focusInterval);
          break;

        case 13:
          this.$nextTick(() => {
            if (this.isShowQuickMsgToggle) {
              this.selectQuickMessage(this.quickMessages[this.focus]["id"]);
            }
          });

          break;
      }
    },

    keyDownAction: function (event) {
      switch (event.keyCode) {
        // 38 — up
        case 38:
          if (this.focus === null) {
            this.focus = 0;
          }

          if (this.focus > 0) this.focus--;
          else this.focus = this.quickMessages.length - 1;

          break;

        // 40 — down
        case 40:
          if (this.focus === null) {
            this.focus = 0;
          }

          if (this.focus < this.quickMessages.length - 1) this.focus++;
          else this.focus = 0;

          break;
      }
    },

    selectQuickMessage(id) {
      let msg = this.quickMessages.filter(function (el) {
        return el.id === id;
      });
      this.text = msg[0].description ? msg[0].description : msg[0].title;
      this.isShowQuickMsgToggle = false;
    },

    async getQuickMessages(textSearch) {
      const keyword = textSearch.replace("#", "");

      let payload = {
        text: textSearch.replace("#", ""),
      };

      let response = await QuickMessageRepository.search(payload);

      const { data } = response;

      this.quickMessages = data;

      if (data.length === 0) {
        this.qmNoResultCount += 1;
      } else {
        this.qmNoResultCount = 0;
      }

      this.isShowQuickMsgToggle = this.qmNoResultCount < 2;
    },
    handlePaste(e) {
      if (e.clipboardData.files.length > 0) {
        this.$refs.fileInput.files = e.clipboardData.files;
        this.onAttachmentChange();
        setTimeout(() => {
          this.text = "";
        }, 5);
      }
    },
    createObjectURL(file) {
      return window.URL.createObjectURL(file);
    },
    byteToMB(size) {
      return size / 1000 / 1000;
    },
    openAttachment() {
      // if (!this.activeChannel.operatorAssigned) {
      //   this.$refs.inputBox.focus();
      //   return;
      // }
      if (this.isShowEmojiPicker) {
        return;
      }
      this.$refs.fileInput.value = null;
      this.$refs.fileInput.click();
    },
    removeAttachment() {
      this.$refs.fileInput.value = null;
      this.attachment = {};
    },
    onAttachmentChange() {
      const self = this;
      const filelist = [...this.$refs.fileInput.files];
      const file = filelist[0];
      if (file) {
        if (isImage(file.name)) {
          var reader = new FileReader();
          reader.onload = (e) => {
            self.attachment = {
              file,
              fileUrl: e.target.result,
              fileName: file.name,
              fileSize: file.size,
              maxSize: config.maxImageSize,
              isExceedLimit: file.size > config.maxImageSize,
            };
          };
          reader.readAsDataURL(file);
        } else if (isVideo(file.name)) {
          self.attachment = {
            file,
            fileName: file.name,
            fileSize: file.size,
            maxSize: config.maxVideoSize,
            isExceedLimit: file.size > config.maxVideoSize,
          };
        } else if (isDoc(file.name)) {
          self.attachment = {
            file,
            fileName: file.name,
            fileSize: file.size,
            maxSize: config.maxDocSize,
            isExceedLimit: file.size > config.maxDocSize,
          };
        } else {
          // MISSING DISPLAY MESSAGE
          return;
        }
      }
    },
    closeEmoji() {
      this.isShowEmojiPicker = false;
    },
    openEmoji() {
      // if (!this.activeChannel.operatorAssigned) {
      //   this.$refs.inputBox.focus();
      //   return;
      // }
      if (this.attachment.fileUrl) {
        return;
      }
      this.isShowEmojiPicker = !this.isShowEmojiPicker;
    },
    addEmoji(emoji) {
      this.text += emoji;
    },
    sendMessage() {
      if (this.isTranslating) return; // If translation have finish don't allow to send message
      if (this.isShowQuickMsgToggle) return;
      this.isShowEmojiPicker = false;
      const roomId = this.activeRoom.roomId;
      if (this.attachment.file) {
        if (this.attachment.isExceedLimit) {
          return;
        }
        this.$emit("send-attachment", this.attachment, roomId);
        this.attachment = {};
      } else if (this.text.trim()) {
        this.$emit("send-text", this.text, this.translate, roomId);
        this.text = "";
      }
    },
    startTyping() {
      if (this.isTyping) {
        return;
      }
      this.typing(true);
    },
    stopTyping() {
      if (!this.isTyping) {
        return;
      }
      this.typing(false);
    },
    manualTranslate: _.debounce(async function (text) {
      if (text) {
        const response = await TranslateRepository.translate({
          text,
          target: this.activeChannel.detectedLanguage,
        });
        this.translate = response?.data?.data;
        this.isShowTranslateToggle = true;
      } else {
        this.translate = "";
        this.isShowTranslateToggle = false;
      }
      this.isTranslating = false;
    }, 200),

    typing(isTyping = false) {
      this.isTyping = isTyping;
      if (!this.activeRoom?.token) return;

      // ChatMessageRepository.typing({
      //   token: this.activeRoom.token,
      //   isTyping: isTyping,
      // })
      //   .then((response) => { })
      //   .catch((err) => { });
    },
    onInputFocus(ev) {
      // if (this.activeChannel?.isAutoTranslate && this.text.length > 0) {
      //   this.isShowTranslateToggle = true;
      //   this.manualTranslate(this.text);
      // } else {
      //   this.isShowTranslateToggle = false;
      // }
      if (!this.activeRoom.operatorAssigned) {
        // this.$refs.inputBox.blur();
        // ev.preventDefault();
        // this.$bvModal
        //   .msgBoxConfirm(this.$t("alert.autoAssignIfReply"), {
        //     title: this.$t("alert.areYouSure"),
        //     size: "sm",
        //     buttonSize: "sm",
        //     okVariant: "primary",
        //     okTitle: <span ref="bvAgreeBtn">{this.$t("button.agree")}</span>,
        //     cancelTitle: this.$t("button.cancel"),
        //     cancelVariant: "outline-secondary",
        //     hideHeaderClose: false,
        //     centered: true,
        //   })
        //   .then((value) => {
        //     if (value) {
        //       this.$emit("assign-by-click");
        //       this.activeChannel.operatorAssigned = this.userData.id;
        //       this.$refs.inputBox.focus();
        //     }
        //   });
      }
    },
  },
};
</script>

<style lang="scss">
.chat-app-form {
  textarea.form-control {
    padding: 8px !important;
    overflow-y: auto !important;
    border: unset !important;
    box-shadow: unset !important;
  }

  .input-group:not(.bootstrap-touchspin):focus-within {
    box-shadow: unset !important;
  }
}

li.focus {
  border-bottom: 1px solid red !important;
  background: #a6669d;
  color: white;
}

li.msg-title-message {
  border-bottom: 1px solid #f0f0f0 !important;
  margin-bottom: 0rem;
  display: inherit;
}

a.text-msg-title {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  padding: 3px;
  padding-left: 10px;
  font-size: 13px;
}
</style>
